/*
 * Shared modal shell. Header, scrollable body, optional footer.
 * Wraps MUI Modal for focus trap and scroll lock.
 */
import React from 'react'
import Modal from '@mui/material/Modal'
import Icon from './Icon'

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(11, 41, 38, 0.45)',
    backdropFilter: 'blur(2px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    boxSizing: 'border-box',
    outline: 'none',
}

const GpModalShell = React.forwardRef(function GpModalShell(
    { open, title, width = 520, onClose, children, footer },
    ref
) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-label={title}
            disableScrollLock
            disableEnforceFocus
            disableAutoFocus
        >
            <div
                ref={ref}
                style={overlayStyle}
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget) onClose()
                }}
            >
                <div
                    style={{
                        background: 'var(--gp-card)',
                        borderRadius: 'var(--gp-r-xl)',
                        width: '100%',
                        maxWidth: width,
                        minWidth: 0,
                        boxShadow: '0 20px 60px rgba(11, 41, 38, 0.25)',
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                        outline: 'none',
                        boxSizing: 'border-box',
                    }}
                >
                    <header
                        style={{
                            padding: '20px 24px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderBottom: '1px solid var(--gp-hairline)',
                        }}
                    >
                        <h2
                            style={{
                                margin: 0,
                                marginRight: 16,
                                font: '500 18px/1.2 var(--gp-font)',
                                color: 'var(--gp-ink)',
                                textIndent: 0,
                            }}
                        >
                            {title}
                        </h2>
                        <button
                            type="button"
                            onClick={onClose}
                            aria-label="Close"
                            style={{
                                width: 32,
                                height: 32,
                                flexShrink: 0,
                                borderRadius: '50%',
                                border: 'none',
                                background: 'var(--gp-surface)',
                                color: 'var(--gp-ink-mute)',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background 0.15s ease, color 0.15s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'var(--gp-hairline)'
                                e.currentTarget.style.color = 'var(--gp-ink)'
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'var(--gp-surface)'
                                e.currentTarget.style.color = 'var(--gp-ink-mute)'
                            }}
                        >
                            <Icon name="close" size={16} stroke={2} />
                        </button>
                    </header>

                    <div
                        style={{
                            padding: '20px 24px 8px',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            flex: 1,
                            minWidth: 0,
                            minHeight: 0,
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                        }}
                    >
                        {children}
                    </div>

                    {footer && (
                        <footer
                            style={{
                                padding: '16px 24px 20px',
                                display: 'flex',
                                gap: 10,
                                justifyContent: 'flex-end',
                                borderTop: '1px solid var(--gp-hairline)',
                                background: 'var(--gp-card)',
                            }}
                        >
                            {footer}
                        </footer>
                    )}
                </div>
            </div>
        </Modal>
    )
})

export default GpModalShell
